import Store from '@app/store';
import RouterFunctions from '@app/router/functions';
/**
 * Prefetch page data for a given URL
 *
 * @param url Url to prefetch
 */
export const prefetch = async (url) => {
    // Abort if prefetching is disabled or we're on a touch device
    if (!window.PREFETCH_LINKS || window.matchMedia('(hover: none)').matches) {
        return;
    }
    // Wait for all routes to be loaded before starting to handle prefetches
    await Store.STATE.routesLoaded;
    // Get normalized URL pathname
    const urlObject = new URL(url);
    const path = urlObject.pathname;
    // Dont prefetch is data already exists or the route does not exist
    if (Store.STATE.pageData[path] || !RouterFunctions.routeExists(path)) {
        return;
    }
    if (window.laravelDebug) {
        console.log('🚀 Prefetching ' + path);
    }
    // Actually prefetch the data
    Store.ACTIONS.loadPageData(path).then(data => {
        if (data) {
            Store.STATE.pageData[path].__prefetched__ = true;
        }
    });
};
